import { makeStyles } from '../styles';
import { hexToRgba } from '../utils/hexToRgba';
import { resolveThemeColorProp } from '../utils/resolveThemeColorProp';

export const useStyles = makeStyles([
  [
    'tag',
    (theme, [originColor, variant, clickable]) => {
      const color = resolveThemeColorProp(theme, originColor);
      return [
        `
				display: inline-flex;
				justify-content: center;
				align-items: center;
				font-size: 13px;
				line-height: 2;
				border-radius: 16px;
				border: none;
				outline: none;
				padding: 0;
				transition: opacity 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
				white-space: nowrap;
				vertical-align: middle;
				text-decoration: none;
				cursor: default;
				box-sizing: border-box;
			`,
        variant === 'filled' &&
          `
				background-color: ${color || theme.color.text.B};
				border: 1px solid ${color || theme.color.text.B};
				color: ${theme.color.text[color ? 'white' : 'B6']};
			`,
        variant === 'outlined' &&
          `
				background-color: transparent;
				border: 1px solid ${color || theme.color.text.B};
				color: ${color || theme.color.text.B6};
			`,
        clickable &&
          `
				-webkit-tap-highlight-color: transparent;
				cursor: pointer;

				&:active {
					box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
				}
			`,
        clickable &&
          variant === 'filled' &&
          `
				&:hover,
				&:focus {
					background-color: ${hexToRgba(color || theme.color.text.B2, 0.8)};
				}
			`,
        clickable &&
          variant === 'outlined' &&
          `
				&:hover,
				&:focus {
					background-color: ${hexToRgba(color || theme.color.text.B6, 0.08)};
				}
			`
      ];
    }
  ],
  [
    'label',
    `
		display: flex;
		align-items: center;
		padding: 0 8px;
		white-space: nowrap;
		user-select: none;
		cursor: inherit;
	`
  ]
]);
